import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CompanionConversationMessageModel,
  CompanionConversationModel,
  ConversationMessagesResponseModel,
  ConversationsResponseModel,
} from '@nimbus-library/features/companion-chat/models/companion-conversation.model';
import { CompanionHttpService } from '@nimbus-library/features/companion-chat/services/companion-http.service';

@Injectable({ providedIn: 'root' })
export class CompanionApiClient {
  public constructor(private readonly httpService: CompanionHttpService) {}

  // GET

  public getConversations(tenantId: string, userId: string, pageSize: number, skip?: string): Observable<ConversationsResponseModel> {
    const params: Record<string, string | number> = { userId, pageSize };
    if (skip) {
      params['continuationToken'] = skip;
    }
    return this.httpService.get(`companion/${encodeURIComponent(tenantId)}/companion/conversations`, params);
  }

  public getConversationMessages(
    tenantId: string,
    conversationId: string,
    userId: string,
    pageSize: number,
    skip?: string,
  ): Observable<ConversationMessagesResponseModel> {
    const params: Record<string, string | number> = { userId, pageSize };
    if (skip) {
      params['continuationToken'] = skip;
    }
    return this.httpService.get(
      `companion/${encodeURIComponent(tenantId)}/companion/conversation/${encodeURIComponent(conversationId)}/messages`,
      params,
    );
  }

  // POST

  public postConversation(
    tenantId: string,
    userId: string,
    model: CompanionConversationMessageModel,
    conversationId?: string,
  ): Observable<CompanionConversationModel> {
    const encodedTenantId = encodeURIComponent(tenantId);
    const path = conversationId
      ? `companion/${encodedTenantId}/companion/conversation/${encodeURIComponent(conversationId)}`
      : `companion/${encodedTenantId}/companion/conversation`;
    return this.httpService.post(path, model, {}, { userId });
  }

  public searchConversations(
    tenantId: string,
    userId: string,
    query: string,
    pageSize: number,
    skip?: string,
  ): Observable<ConversationsResponseModel> {
    const params: Record<string, string | number> = { userId, pageSize };
    if (skip) {
      params['continuationToken'] = skip;
    }
    return this.httpService.post(
      `companion/${encodeURIComponent(tenantId)}/companion/conversations/search`,
      { titleFilter: query },
      {},
      params,
    );
  }

  // PATCH

  public patchConversationTitle(tenantId: string, userId: string, conversationId: string, title: string): Observable<void> {
    return this.httpService.patch(
      `companion/${encodeURIComponent(tenantId)}/companion/conversation/${encodeURIComponent(conversationId)}`,
      { title },
      { userId },
    );
  }

  // DELETE

  public deleteConversation(tenantId: string, userId: string, conversationId?: string): Observable<void> {
    const encodedTenantId = encodeURIComponent(tenantId);
    const path = conversationId
      ? `companion/${encodedTenantId}/companion/conversation/${encodeURIComponent(conversationId)}`
      : `companion/${encodedTenantId}/companion/conversations`;
    return this.httpService.delete(path, { userId });
  }
}
